import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// components
import Faqs from "elements/Faqs";
import BottomBanner from "elements/BottomBanner";
import LandingBanner from "elements/LandingBanner";
import PopularGameSlider from "elements/games_elements/PopularGameSlider";
import WelcomePromotions from "elements/WelcomePromotions";
import PromotionSlider from "elements/PromotionSlider";
import GameSlider from "elements/games_elements/GameSlider";
// import SingleCategoryGames from "elements/games_elements/SingleCategoryGames";
import Winner from "elements/Winner";

//Landings
import CasinoLanding from "./Landings/CasinoLanding";
import PokerLanding from "./Landings/PokerLanding";
import BingoLanding from "./Landings/BingoLanding";
import SportsLanding from "./Landings/SportsLanding";

import { __ } from "services/Translator";
import swal from "sweetalert";

export default function Landing(props) {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/account-activated") {
      swal({
        title: __("Successfully Activated"),
        // text: __(
        //   "A password recovery email has been sent to your provided email address."
        // ),
        icon: "success",
      });
    }
  }, [location.pathname]);

  return (
    <>
      {props.landingType == "casino" && <CasinoLanding {...props} />}
      {props.landingType == "sport" && <SportsLanding {...props} />}
      {props.landingType == "poker" && <PokerLanding {...props} />}
      {props.landingType == "bingo" && <BingoLanding {...props} />}
    </>
  );
}
